import React from 'react'
import { Card, Flex } from 'antd'
import dayjs from 'dayjs'
import _ from 'lodash'
import Title from 'antd/es/typography/Title'
import { BarChart } from '@mui/x-charts'
import { SLOT_COLORS } from '../../Common/Color'

export default function HourChart ({ slots }) {
  const format = (hours) => {
    return Object.keys(hours).map((hour) => ({
      name: `${hour}h`,
      patientSlot: hours[hour].filter(slot => slot.type === 'PatientSlot').length,
      cleaningSlot: hours[hour].filter(slot => slot.type === 'CleaningSlot').length,
      maintenanceSlot: hours[hour].filter(slot => slot.type === 'MaintenanceSlot').length
    }))
  }

  const hours = _.groupBy(slots, (slot) => {
    return dayjs(slot.begin_date).format('H')
  })

  return (
    <Card>
      <Flex vertical>
        <Title level={5} style={{ textAlign: 'center' }}>
          {'Nombre de RDV par heure'}
        </Title>
        <BarChart
          dataset={format(hours)}
          xAxis={[{ scaleType: 'band', dataKey: 'name' }]}
          series={[
            { dataKey: 'patientSlot', label: 'Patient', stack: 'total' },
            { dataKey: 'cleaningSlot', label: 'Nettoyage', stack: 'total' },
            { dataKey: 'maintenanceSlot', label: 'Maintenance', stack: 'total' }
          ]}
          colors={[SLOT_COLORS.PatientSlot, SLOT_COLORS.CleaningSlot, SLOT_COLORS.MaintenanceSlot]}
          height={200} />
      </Flex>
    </Card>
  )
}
